import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { createTheme as createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import {
  Button,
  Container,
  CssBaseline,
  Grid,
  Typography,
  TextField,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import { login, temporaryLogin } from "../../redux/auth/actions.js";
import * as api from "../../redux/api/actions.js";
import LoginBackground from "../../assets/img/login-background.jpg";
import ZoetisLogo from "../../assets/img/logo_corte.png";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#EA5D0D",
    },
  },
});

class TemporaryLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      redirectToGigya: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState(() => ({ [name]: value }));
  };

  async handleSubmit() {
    const { email, password } = this.state;
    // Esta é uma nova action que precisará ser criada no Redux
    // e apontará para o endpoint `Authentication/temporary-login`
    await this.props.temporaryLogin({ login: email, password });
  }

  onEnterPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey && this.canSubmit()) {
      e.preventDefault();
      this.handleSubmit();
    }
  };

  canSubmit() {
    return this.state.email && this.state.password;
  }

  componentDidUpdate(prevProps) {
    if (this.props.success && !prevProps.success) {
      this.setState({ redirectToGigya: true });
    }
  }

  render() {
    if (this.state.redirectToGigya) {
      return (
        <Redirect
          to={{
            pathname: "/register-gigya",
            state: { isFirstLogin: true },
          }}
        />
      );
    }

    if (this.props.loading) {
      return (
        <Backdrop open>
          <CircularProgress color="inherit" />
        </Backdrop>
      );
    }

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Grid container className="page-login">
          <Grid
            item
            lg={6}
            md={0}
            className="page-login-form"
            style={{ backgroundImage: `url(${LoginBackground})` }}
          />
          <Grid item md={12} lg={6}>
            <Container maxWidth="xs">
              <Typography
                component="div"
                style={{ height: "100vh", marginTop: "100px" }}
              >
                <img
                  src={ZoetisLogo}
                  alt="Zoetis Gerar"
                  className="p-full-width"
                  style={{ width: "100%" }}
                />

                <Typography
                  variant="h6"
                  style={{ textAlign: "center", margin: "1em 0" }}
                >
                  Acesso Inicial
                </Typography>

                {this.props.error && (
                  <Alert severity="error" style={{ marginTop: "1em" }}>
                    {this.props.error.title}
                  </Alert>
                )}

                <Container disableGutters>
                  <Container disableGutters style={{ marginTop: "1em" }}>
                    <TextField
                      id="email"
                      label="E-mail"
                      name="email"
                      variant="outlined"
                      type="email"
                      onChange={this.handleChange}
                      value={this.state.email}
                      style={{ width: "100%", backgroundColor: "white" }}
                    />
                  </Container>

                  <Container disableGutters style={{ marginTop: "1em" }}>
                    <TextField
                      id="password"
                      label="Senha Temporária"
                      name="password"
                      variant="outlined"
                      type="password"
                      onChange={this.handleChange}
                      onKeyDown={this.onEnterPress}
                      style={{
                        width: "100%",
                        backgroundColor: "white",
                      }}
                    />
                  </Container>

                  <Container disableGutters style={{ marginTop: "1em" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      style={{ width: "100%" }}
                      disabled={!this.canSubmit() || this.props.loading}
                      onClick={this.handleSubmit}
                    >
                      Entrar
                    </Button>
                  </Container>
                </Container>
              </Typography>
            </Container>
          </Grid>
        </Grid>
      </ThemeProvider>
    );
  }
}

// Atualizar mapDispatchToProps
const mapDispatchToProps = (dispatch) => {
  return {
    temporaryLogin: (params) => dispatch(temporaryLogin(params)),
  };
};

const mapStateToProps = (state) => ({
  error: api.getApiError(state, `Authentication/temporary-login`) || false,
  success: api.getApiResult(state, `Authentication/temporary-login`) || false,
  loading: api.getApiLoading(state, `Authentication/temporary-login`),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(TemporaryLogin));
